<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="100px">
            <el-form-item class='edit-form' label="代理商" label-width="150px">
                <el-button @click="agentShow">选择代理商</el-button>
                <el-row v-show="Agent.Customer!=''||Agent.Address!=''||Agent.AgentTel!=''" :class="{agent:showAgent}">
                    <el-col :span="24" style="width: 800px">
                        <div>
                            <span style="margin-right: 15px">{{Agent.AgentCode}}</span>
                            <span style="margin-right: 15px">{{Agent.Customer}}</span>
                            <span style="margin-right: 15px">{{Agent.Address}}</span>
                            <span style="margin-right: 15px">{{Agent.AgentTel}}</span>
                        </div>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item class='edit-form' label="业务员" label-width="150px">
                <el-select v-model="Form.SaleEmployeeId" filterable placeholder="请选择或搜索">
                    <el-option v-for="item in EmployallData" :label="item.value" :value="item.Id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品" label-width="150px" style="min-width:600px;">
                <div style="padding-bottom:10px;">
                    <el-button icon="plus" @click="ActionProduct">选择商品</el-button>
                </div>
                <template>
                    <el-table :data="PageGoodsList" style="width:100%;">
                        <el-table-column prop="ProName" label="名称" width="180">
                        </el-table-column>
                        <el-table-column label="数量" width="200">
                            <template scope="scope">
                                <el-input-number :min="1" v-model="scope.row.ProNum" @change="handleChangeGoods(scope.row)" style="margin-top:10px;"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template scope="scope">
                                <el-button @click="delGoods(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<div class="total-sal-price">总计：{{getTotalGoodsSalePrice}}元</div>-->
                </template>
            </el-form-item>
            <el-form-item label="赠品" label-width="150px">
                <div style="padding-bottom:10px;">
                    <el-button icon="plus" @click="ActionGifts">添加赠品</el-button>
                </div>
                <template>
                    <el-table :data="PageGiftsList" style="width:100%;">
                        <el-table-column prop="ProName" label="名称" width="180">
                        </el-table-column>
                        <el-table-column label="数量" width="200">
                            <template scope="scope">
                                <el-input-number :min="1" v-model="scope.row.ProNum" style="margin-top:10px;"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template scope="scope">
                                <el-button style="float: right" @click="delGifts(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-form-item>
            <el-form-item label="选择收货地址" label-width="150px" v-show="this.DefaultAddress.Address!=undefined">
                <span style="margin-left: 30px">{{DefaultAddress.Address}}</span>
                <el-button style="margin-left: 30px" @click="AddressShow">更换地址</el-button>
            </el-form-item>
            <el-form-item label="收货人及联系方式" label-width="150px" v-show="this.DefaultAddress.Consignee!=undefined&&this.DefaultAddress.ConsigneeTel!=undefined">
                <span style="margin-left: 30px">{{DefaultAddress.Consignee}}</span>
                <span style="margin-left: 30px">{{DefaultAddress.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item label="寄送方式" label-width="150px">
                <el-radio-group v-model="Form.SendMode">
                    <el-radio v-for="item in transportList" :label="item.Id">{{item.ParmName}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付方式" label-width="150px">
                <el-radio-group v-model="Form.PayMode">
                    <el-radio v-for="item in PayList" :label="item.Id">{{item.ParmName}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" label-width="150px">
                <el-input type="textarea" placeholder="请输入备注(选填)" v-model="Form.OrderRemark"></el-input>
            </el-form-item>
            <el-form-item>
                <el-col :span="24" style="display: flex;justify-content: center">
                    <el-button @click="submit">确定</el-button>
                </el-col>
            </el-form-item>
        </el-form>
        <el-dialog title="选择代理商" v-model="dialog.agentVisible" :close-on-click-modal="false" v-on:close="AgentSure(1)">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="代理商编号">
                    <el-input placeholder="请输入编号" style="width:120px" v-model="query.AgentId"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input placeholder="请输入姓名" style="width:120px" v-model="query.AgentName"></el-input>
                </el-form-item>
                <el-form-item label="所属区域">
                    <el-select placeholder="选择省" style="width:100px" @change="Province" v-model="query.ProvinceSelcted">
                        <el-option v-for="item in ProvinceList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <el-select placeholder="选择市" style="width:100px" @change="City" v-model="query.CitySelected">
                        <el-option v-for="item in CityList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <el-select placeholder="选择区" style="width:100px" v-model="query.AreaSelected">
                        <el-option v-for="item in AreaList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getAgentList">查询</el-button>
                </el-form-item>
                <div v-if="!loading4">
                    <el-row v-if="AgentList.length>0">
                        <span v-for="item in AgentList" style="width: 100%">
                            <div style="display: inline-block;width: 19%;margin-top: 20px">
                                <el-radio class="radio" :label="item.Id" v-model="Form.AgentId">{{item.Customer}}</el-radio>
                            </div>
                        </span>
    
                    </el-row>
                    <el-row v-else>
                        <el-col :span="24" style="margin-top: 20px;text-align: center">
                            <span>暂无数据</span>
                        </el-col>
                    </el-row>
                </div>
                <div v-else>
                    <span style="text-align: center">正在加载中....</span>
                </div>
                <el-row style="margin-top: 50px;display: flex;justify-content: flex-end;margin-bottom: -10px">
                    <el-pagination v-show="AgentList.length>0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize*1">
                    </el-pagination>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center">
                <el-button type="primary" @click="AgentSure(2)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="DailogTile" v-model="dialog.productVisible" size="small" :close-on-click-modal="false" v-on:close="GoodsSure(1)">
            <el-row style="text-align: center;border: 1px solid gray">
                <el-col :span="12" style="height: 50px;line-height: 50px" :class="{active:isProActive}">
                    <span @click="activePro" class="myItem">单品</span>
                </el-col>
                <el-col :span="12" style="height: 50px;line-height: 50px" :class="{active:isPacActive}">
                    <span @click="activePac" class="myItem">套餐</span>
                </el-col>
            </el-row>
            <el-row style="border-bottom: 1px solid gray" v-show="GoodsList.length>0">
                <el-row>
    
                    <el-col :span="24" style="margin-top: 10px;">
                        <strong>已选</strong>
                    </el-col>
                </el-row>
                <el-row>
                    <el-tag v-for="tag in GoodsList" :closable="true" type="gray" style="margin: 10px 15px" @close="tagClose(tag)">
                        {{tag.ProName}}
                    </el-tag>
                </el-row>
            </el-row>
            <el-row style="margin-top: 20px" v-if="isProActive">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="单品编号">
                        <el-input placeholder="请输入单品编号" style="width:150px" v-model="queryProduct.ProId"></el-input>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input placeholder="请输入名称" style="width:150px" v-model="queryProduct.ProName"></el-input>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-select placeholder="-请选择-" style="width:150px" v-model="queryProduct.ProClass" v-show="flshow" @visible-change="selChange">
                            <el-option v-for="option in ProductClass" :value="option.Value" :label="option.Key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="种类">
                        <el-select placeholder="-请选择-" style="width:150px" v-model="queryProduct.ProAttr" v-show="zlshow" @visible-change="selChange">
                            <el-option v-for="option in Category" :value="option.Id" :label="option.ParmName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getProList">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row style="margin-top: 20px" v-else>
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="套餐编号">
                        <el-input placeholder="请输入套餐编号" style="width:150px" v-model="queryPackage.ProCode"></el-input>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input placeholder="请输入名称" style="width:150px" v-model="queryPackage.ProName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getPacList">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row>
                <template v-if="!loading1">
                    <el-checkbox-group @change="checkPackage" v-model="checkPacList">
                        <el-checkbox v-for="item in PackageList" :label="item.ProductId" style="width: 18%;margin-top: 20px" class="mycheckbox">{{item.ProName}}</el-checkbox>
                    </el-checkbox-group>
                </template>
                <template v-else>
                    <div style="text-align: center">正在加载中......</div>
                </template>
            </el-row>
            <el-row>
                <template v-if="!loading3">
                    <el-checkbox-group v-model="checkProList" @change="checkProduct">
                        <el-checkbox v-for="item in ProductList" :label="item.ProductId" style="width: 18%;margin-top: 20px" class="mycheckbox">{{item.ProName}}</el-checkbox>
                    </el-checkbox-group>
                </template>
                <template v-else>
                    <div style="text-align: center">正在加载中......</div>
                </template>
            </el-row>
            <el-row style="margin-top: 50px;display: flex;justify-content: flex-end;margin-bottom: -10px">
                <el-pagination v-show="ProductList.length>0" @size-change="handleSizeChange" @current-change="handleCurrentChange2" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize*1">
                </el-pagination>
                <el-pagination v-show="PackageList.length>0" @size-change="handleSizeChange" @current-change="handleCurrentChange3" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize*1">
                </el-pagination>
            </el-row>
            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center">
                <el-button type="primary" @click="GoodsSure(2)">确 定</el-button>
            </span>
        </el-dialog>
    
        <el-dialog title="选择收货地址" v-model="dialog.addAddressVisible">
            <el-row>
                <el-table :data="AgentAddress" border @row-click="myRow" style="width: 100%">
                    <el-table-column prop="Address" label="收货地址">
                    </el-table-column>
                    <el-table-column prop="Consignee" label="收货人" width="180">
                    </el-table-column>
                    <el-table-column prop="ConsigneeTel" label="联系方式">
                    </el-table-column>
                    <el-table-column prop="IsDefault" label="是否默认">
                        <template scope="scope">
                            <el-button v-if="scope.row.IsDefault" type="success">当前默认</el-button>
                            <el-button v-else type="info" @click="setDefaultAddress(scope.$index, scope.row)">设为默认</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <el-form :inline="true" class="demo-form-inline" style="margin-top: 15px">
                <el-form-item>
                    <el-select placeholder="选择省" style="width:130px" @change="Province" v-model="query.ProvinceSelcted">
                        <el-option v-for="item in ProvinceList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select placeholder="选择市" style="width:130px" @change="City" v-model="query.CitySelected">
                        <el-option v-for="item in CityList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select placeholder="选择区" style="width:130px" v-model="query.AreaSelected">
                        <el-option v-for="item in AreaList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入详细地址" style="width:450px" v-model="AddAddress.ConsigneeAdress"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入联系人" style="width:200px" v-model="AddAddress.Consignee"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入联系方式" style="width:200px" v-model="AddAddress.ConsigneeTel"></el-input>
                </el-form-item>
                <el-form-item label="设为默认地址">
                    <el-switch on-text="" off-text="" v-model="AddAddress.IsDefault"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addAddress">确认添加</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
    </div>
</template>
<script>
import addOrder from './addOrder.js'
module.exports = addOrder;
</script>


<style lang="scss" rel="stylesheet/scss">
@import "./src/common/sass/base.scss";

.edit-form {
    width: 370px;
}

.active {
    background-color: #bdbdbd;
}

.myItem {
    display: block;
    width: 100%;
    height: 50px;
}

.agent {
    display: none;
}

.mycheckbox {

    overflow: hidden;
}

.mycheckbox:nth-child(1) {
    margin-left: 15px;
}

.total-sal-price {
    font-weight: bold;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// addOrder.vue?345a3516